import React from 'react'

import { MODAL_ROUTE_PATH } from 'router/modalRoutes'

import { ResetPasswordConfirmModal } from 'pages/Emails/ResetPasswordConfirm/components'

import MobileModalLang from 'components/SetLanguage/MobileModalLang/MobileModalLang'
import SignIn from 'components/SignIn/SignIn'
import SignUp from 'components/SignUp/SignUp'
import SportModal from 'components/SportModal/SportModal'
// import { WheelGame } from 'components/WheelGame/WheelGame'
// import WheelGameHistory from 'components/WheelGame/WheelGameHistory/WheelGameHistory'

interface IModalRoutesItem {
  id: string
  route: string
  Component: React.FC<any>
  bgColor?: string
  hideCloseBtn?: boolean
}

export const modalRoutes: IModalRoutesItem[] = [
  // {
  //   id: 'wheel-game',
  //   route: MODAL_ROUTE_PATH.WHEEL_GAME,
  //   Component: WheelGame,
  //   bgColor: 'transparent',
  // },
  {
    id: 'sport',
    route: MODAL_ROUTE_PATH.CHOOSE_SPORT,
    Component: SportModal,
    bgColor: 'transparent',
    hideCloseBtn: true,
  },
  // {
  //   id: 'reset-password-confirm',
  //   route: MODAL_ROUTE_PATH.RESET_PASSWORD_CONFIRM,
  //   Component: ResetPasswordConfirmModal,
  //   hideCloseBtn: true,
  // },
  // {
  //   id: 'wheel-game-history',
  //   route: MODAL_ROUTE_PATH.WHEEL_GAME_HISTORY,
  //   Component: WheelGameHistory,
  //   bgColor: '#17181b',
  // },
  {
    id: 'sign-in',
    route: MODAL_ROUTE_PATH.SIGN_IN,
    Component: SignIn,
    bgColor: 'transparent',
    hideCloseBtn: true,
  },
  {
    id: 'sign-up',
    route: MODAL_ROUTE_PATH.SIGN_UP,
    Component: SignUp,
    bgColor: 'transparent',
    hideCloseBtn: true,
  },
  {
    id: 'set-language',
    route: MODAL_ROUTE_PATH.SET_LANGUAGE,
    Component: MobileModalLang,
    hideCloseBtn: true,
    bgColor: 'transparent',
  },
]
